import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css';

import VueStates from '@sum.cumo/vue-states'
import Store from './store'

Vue.component(VueCropper)
Vue.use(VueStates)
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  models: { Store },
  render: h => h(App)
}).$mount('#app')
